import oRoot from "base/assets/js/bootstrap.js";
import oImports from 'base/assets/js/imports.js';
import {ImgScrollLoader} from "base/assets/js/widget/ImgScrollLoader.js";
import {Editor} from "base/assets/js/widget/Editor.js";
import {VideoThumb} from "base/assets/js/widget/VideoThumb.js";
import {LazyDownload} from "base/assets/js/widget/LazyDownload.js";
import {JCarousel} from "base/assets/js/widget/JCarousel.js";
import {Map} from "base/assets/js/widget/Map.js";

// css
import "./css/index.scss";
import {DraftSave} from "base/assets/js/widget/DraftSave.js";
import {DraftMenu} from "base/assets/js/widget/DraftMenu.js";
import {DraftDropBtn} from "base/assets/js/widget/DraftDropBtn.js";
import {EditorImg} from "base/assets/js/widget/EditorImg.js";
import {Frame} from "base/assets/js/widget/Frame.js";



// обязательно в глобальную область видимости, иначе плагины не подгрузятся
//window.$ = jQuery;
//window.jQuery = jQuery;


oRoot.core.init( ( oLinker ) => {
	oRoot.brigada.init().then( () => {
		oLinker.setWidgets( {
			Editor,
			EditorImg,
			ImgScrollLoader,
			VideoThumb,
			LazyDownload,
			JCarousel,
			Map,
			DraftSave,
			DraftMenu,
			DraftDropBtn
		} );

		oLinker.setImports( oImports );

		oLinker.link( document );
		window.oLom = oLinker;
	} )
} );